import { render, staticRenderFns } from "./NewsListsShow.vue?vue&type=template&id=3a462454"
import script from "./NewsListsShow.vue?vue&type=script&lang=js"
export * from "./NewsListsShow.vue?vue&type=script&lang=js"
import style0 from "./NewsListsShow.vue?vue&type=style&index=0&id=3a462454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports